import styled from "styled-components";
import { LiveCasinoArenaNavbarButtonDefaultBox } from "./live-casino-arena-navbar-button.default.box";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const LiveCasinoArenaNavbarButtonMrGreenBox = styled(LiveCasinoArenaNavbarButtonDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        &.${ACTIVE} {
            box-shadow: inset 3px 0px 4px rgba(25, 25, 25, 0.7), inset -3px 0px 4px rgba(25, 25, 25, 0.7);
        }
    }
`;
